<div class="geo-tree-dropdown" [class.is-modified]="isModified" [class.is-open]="isOpen">

  <!-- Trigger -->
  <button type="button" class="dropdown-trigger" (click)="toggleDropdown()">
    <span class="trigger-label" [class.placeholder]="selectedIds.length === 0">
      {{ triggerLabel }}
    </span>
    <svg class="trigger-chevron" [class.rotated]="isOpen"
      xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
    </svg>
  </button>

  <!-- Dropdown Panel -->
  @if(isOpen) {
    <div class="dropdown-panel">

      <!-- Search -->
      <div class="tree-search mb-2">
        <div class="search-input-wrap">
          <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.099zm-5.242 1.656a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11"/>
          </svg>
          <input
            type="text"
            class="form-control form-control-sm tree-search-input"
            placeholder="Search territories..."
            [(ngModel)]="searchQuery"
            (input)="onSearchInput()"
          />
        </div>
      </div>

      <!-- Tree -->
      <div class="tree-container">
        @if(loading) {
          <div class="tree-empty">Loading…</div>
        } @else if(flatNodes.length === 0) {
          <div class="tree-empty">No territories match your search.</div>
        }
        @if(!loading) {
        @for(item of flatNodes; track item.node.id) {
          <div
            class="tree-node"
            [style.paddingLeft.px]="item.depth * 20 + 8"
          >
            @if(item.node.children?.length) {
              <button type="button" class="expand-btn" (click)="toggleExpanded(item.node, $event)">
                <svg class="chevron" [class.expanded]="item.node.expanded"
                  xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                </svg>
              </button>
            } @else {
              <span class="expand-placeholder"></span>
            }

            <input
              type="checkbox"
              class="tree-checkbox"
              [checked]="isChecked(item.node)"
              [indeterminate]="isIndeterminate(item.node)"
              (change)="toggleNode(item.node)"
            />

            @if(item.node.color) {
              <span class="color-sq" [style.background]="getColorHex(item.node.color)"></span>
            } @else {
              <span class="color-sq color-sq--empty"></span>
            }

            <span class="node-label">{{ item.node.label }} ({{item.node.code}})</span>
          </div>
        }
        }
      </div>

    </div>
  }

  <!-- Modified hint (outside panel, always visible when modified) -->
  @if(isModified) {
    <div class="modified-hint mt-2">
      <span class="hint-prev">Previously {{ originalNodeCount }} node{{ originalNodeCount !== 1 ? 's' : '' }}</span>
      <span class="hint-arrow"> → </span>
      <span class="hint-new">{{ selectedIds.length }} node{{ selectedIds.length !== 1 ? 's' : '' }}</span>
    </div>
  }

</div>
